















import { IItemStatus, IStatusForSelection } from '@/api/types/response.types'
import Vue from 'vue'

import chicklet from './chicklet.vue'

export default Vue.extend({
  name: 'StatusChicklet',

  components: {
    chicklet,
  },

  props: {
    status: {
      type: Object as () => IStatusForSelection | IItemStatus,
      required: true,
    },
    /* Optionally add "count" -- e.g. count of tasks with this status in the kanban board */
    count: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: 'tiny',
    },
    type: {
      type: String,
      default: 'flat',
    },
    maxWidth: {
      type: String,
      default: null,
    },
  },
})
